import type { ComponentPropsWithoutRef } from 'react';
import { cx } from './cx';

type CardStyle = { featured?: boolean; interactive?: boolean };

/** Card classes for any element — `interactive` adds the hover lift, use it only on links */
export function cardClass({ featured = false, interactive = false }: CardStyle = {}, className?: string): string {
  return cx('card', featured && 'card--featured', interactive && 'card--interactive', className);
}

export function Card({ featured, interactive, className, ...props }: ComponentPropsWithoutRef<'article'> & CardStyle) {
  return <article className={cardClass({ featured, interactive }, className)} {...props} />;
}
